import React from 'react';
import './SiteFooter.css'
import { Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function SiteFooter() {
  const navigate = useNavigate();
  return (
    <Box>

      <Grid className='new-footer'>
        <Grid className='new-footer-content' container >
          <Grid className='new-footer-section' item xs={12} md={4}>
            <h3 >About Us</h3>
            <p style={{paddingRight:"20px"}}>
              We simplify complexity and deliver key technology solutions to attain success for our
              customers and people.
            </p>
          </Grid>

          <Grid className='new-footer-section' item xs={12} md={4}>
            <h3 >Contact Us</h3>
            <p><strong>E-MAIL US</strong></p>
            <p>We are eager to help you. Please reach us for queries:</p>
            <p>General: <b>contact@phyelements.com</b></p>
            <p>Careers: <b>careers@phyelements.com</b></p>
          </Grid>

          <Grid className='new-footer-section' item xs={12} md={4}>
            <h3>Quick Links</h3>
            <ul className='services-points-title arrow-list'>
              <li onClick={() => {navigate('/'); window.scrollTo(0, 0);}}>Home</li>
              <li onClick={() => {navigate('/services/designlayout'); window.scrollTo(0, 0);}}>Design & Layout Capabilities</li>
              <li onClick={() => {navigate('/services/physicaldesign'); window.scrollTo(0, 0);}}>Physical Design & Verification</li>
              {/* <li onClick={() => {navigate('/services/analoglayout'); window.scrollTo(0, 0);}}>Analog Layout</li> */}
              <li onClick={() => {navigate('/careers'); window.scrollTo(0, 0);}}>Careers</li>
              <li onClick={() => {navigate('/contact'); window.scrollTo(0, 0);}}>Contact</li>
            </ul>
          </Grid>
        </Grid>
      </Grid>

      <Grid className='new-footer-bottom'>
        Copyright © 2025 PHYELEMENTS LLP · All rights reserved.
      </Grid>
    </Box>
  );
}

export default SiteFooter;
